import "./about.css";

const About = () => {
  return (
    <section id="about" className="text-center py-5">
      <div className="container">
        <p className="about-text">
          <i>
            <span className="large-text">Since 1979</span>, Alok Fabrications
            has not only built <span className="large-text">equipment</span>,
            we have built <span className="large-text">trust</span>. For over{" "}
            <span className="large-text">46 years</span>, we’ve turned vision
            into durable, custom equipment that stands the test of time. Our
            strong commitment to quality ensures our products not only meet, but
            exceed international standards. Looking ahead, we remain focused on
            pushing the boundaries of innovation, manufacturing equipment that
            not only endures but also shapes the future.
          </i>
        </p>
      </div>
    </section>
  );
};

export default About;
